import { render, staticRenderFns } from "./devolucionProveedorComponent.vue?vue&type=template&id=2705a841&"
import script from "./devolucionProveedorComponent.vue?vue&type=script&lang=js&"
export * from "./devolucionProveedorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports